export const currencyFormat = (value: number) =>
  value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
